import sound from './ambiant.wav';export default sound;